import React, { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { Field, FieldGroup, FieldLabel } from '../ui/Form';
import { Input } from '../ui/Input';

const AddUserForm = () => {
  const { register, closeAddUserModal } = useAppContext();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userType, setUserType] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const types = ["admin", "regular"];

  const validatePassword = (pwd) => {
    if (pwd.length < 12) {
      return "Password must be at least 12 characters long.";
    }
    if (!/[A-Z]/.test(pwd)) {
      return "Password must contain at least one uppercase letter.";
    }
    if (!/[a-z]/.test(pwd)) {
      return "Password must contain at least one lowercase letter.";
    }
    if (!/\d/.test(pwd)) {
      return "Password must contain at least one digit.";
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(pwd)) {
      return "Password must contain at least one special character.";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    // Validate user type
    if (!userType) {
      setError('Please select the user type.');
      return;
    }

    // Validate password length
    if (password.length > 72) {
      setError("Password must be 72 characters or less.");
      return;
    }

    // Validate password strength
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    setLoading(true);
    try {
      await register(username, email, password, userType);
      setSuccess('User created successfully! Closing form...');
      setTimeout(() => {
        closeAddUserModal();
      }, 2000);
    } catch (err) {
      setError(err.message || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <FieldGroup>
        

        <Field>
          <FieldLabel htmlFor="new-username">Username</FieldLabel>
          <Input 
            id="new-username" 
            type="text" 
            required 
            value={username} 
            onChange={e => setUsername(e.target.value)} 
          />
        </Field>

        <Field>
          <FieldLabel htmlFor="new-email">Email Address</FieldLabel>
          <Input 
            id="new-email" 
            type="email" 
            required 
            value={email} 
            onChange={e => setEmail(e.target.value)} 
          />
        </Field>
        <Field>
          <FieldLabel htmlFor="type-name">UserType</FieldLabel>
          <select
            id="type-name"
            name="type"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
          >
            <option value="" disabled>
              Select the user type
            </option>
            {types.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </Field>

        <Field>
          <FieldLabel htmlFor="new-password">Password</FieldLabel>
          <Input 
            id="new-password" 
            type="password" 
            required 
            maxLength="72" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
          />
          <p className="text-xs text-gray-500 mt-1">
            Min 12 chars, with uppercase, lowercase, digit, and special character
          </p>
        </Field>

        {error && <p className="text-sm text-red-500 text-center">{error}</p>}
        {success && <p className="text-sm text-green-500 text-center">{success}</p>}

        <button
  type="submit"
  disabled={loading}
  className={`w-full h-10 mt-2 inline-flex items-center justify-center gap-2 rounded-xl shadow-md backdrop-blur-sm 
    text-sm font-medium transition-all duration-300 ease-in-out
    ${loading
      ? 'bg-blue-500/70 text-white cursor-not-allowed'
      : 'bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg active:scale-[0.98]'
    } disabled:opacity-50 disabled:hover:shadow-none`}
>
  {loading ? (
    <>
      <svg
        className="animate-spin h-4 w-4 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
      <span>Adding User...</span>
    </>
  ) : (
    'Add User'
  )}
</button>

      </FieldGroup>
    </form>
  );
};

export default AddUserForm;